import { ResultOptionEnum } from './result-option.enum';

export class RelatedProfileOptionsModel {
  public ResultBehavior: ResultOptionEnum;
  public BillingContact: boolean;
  public Editor: boolean;
  public MainContact: boolean;
  public ReceivesCommunication: boolean;
  public PrimaryRelationship: boolean;
  public UseRelatedAs: boolean;
  public RelatedAs: number;

  public constructor() {
    this.ResultBehavior = ResultOptionEnum.Add;
    this.BillingContact = false;
    this.Editor = false;
    this.MainContact = false;
    this.ReceivesCommunication = false;
    this.PrimaryRelationship = false;
    this.UseRelatedAs = false;
    this.RelatedAs = 0;
  }
}
